var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGroup = function SvgGroup(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "group_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 18.4 15",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".group_svg__st0{fill:#374a67}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group_svg__group",
    transform: "translate(-1 -4.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "group_svg__Pfad_1275",
    d: "M7.4 11.6c1.9 0 3.5-1.6 3.5-3.5S9.3 4.6 7.4 4.6 3.9 6.1 3.9 8.1c0 1.9 1.6 3.5 3.5 3.5",
    className: "group_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "group_svg__Pfad_1276",
    d: "M12 14.5c-2.5-2.5-6.5-2.6-9.1-.1A6.42 6.42 0 0 0 1 19c0 .3.3.6.6.6h11.6c.3 0 .6-.3.6-.6 0-.7-.1-1.3-.3-1.9-.3-1-.8-1.9-1.5-2.6",
    className: "group_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "group_svg__Ellipse_168",
    cx: 14.8,
    cy: 9.3,
    r: 2.6,
    className: "group_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "group_svg__Pfad_1277",
    d: "M14.8 12.6c-.8 0-1.6.2-2.3.6.1.1.3.2.4.4.8.9 1.5 1.9 1.8 3l.3 1.2h3.9c.3 0 .6-.3.6-.6-.1-2.5-2.1-4.6-4.7-4.6",
    className: "group_svg__st0"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGroup);
export default ForwardRef;